import React from 'react';
import { connect } from 'react-redux';
import { changeOtp } from '../../../redux/userAuthentication/userAuth.actions';
import { onLoginEnter } from '../../../utils/commonFunctions';

const mapStateToProps = (state) => {
	return {
		otp: state.rootReducer.loginDetails.otp,
	};
};

const mapDispatchToProps = (dispatch) => {
	return {
		onOtpChange: (otp) => dispatch(changeOtp(otp)),
	};
};

const OtpField = ({ otp, onOtpChange }) => (
	<input
		aria-label="otp"
		onKeyDown={onLoginEnter}
		type="text"
		name="txtOtp"
		id="txtOtp"
		className="step-password-field"
		placeholder="Enter OTP"
		value={otp}
		onChange={(e) => onOtpChange(e.target.value)}
	/>
);

export default connect(mapStateToProps, mapDispatchToProps)(OtpField);
